
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { Switch } from "@/components/ui/switch";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";

interface AttractionDetailsProps {
  entranceFee: string;
  setEntranceFee: (value: string) => void;
  attractionType: string;
  setAttractionType: (value: string) => void;
  suggestedDuration: string;
  setSuggestedDuration: (value: string) => void;
  exhibits: string;
  setExhibits: (value: string) => void;
  historicalSignificance: string;
  setHistoricalSignificance: (value: string) => void;
  isIndoor: boolean;
  setIsIndoor: (value: boolean) => void;
  bestTimeToVisit: string;
  setBestTimeToVisit: (value: string) => void;
  isExistingPlace?: boolean;
}

export function AttractionDetails({
  entranceFee,
  setEntranceFee,
  attractionType,
  setAttractionType,
  suggestedDuration,
  setSuggestedDuration,
  exhibits,
  setExhibits,
  historicalSignificance,
  setHistoricalSignificance,
  isIndoor,
  setIsIndoor,
  bestTimeToVisit,
  setBestTimeToVisit,
  isExistingPlace = false
}: AttractionDetailsProps) {
  return (
    <div className="space-y-4">
      <div className="space-y-2">
        <Label>Attraction Type</Label>
        <Select 
          value={attractionType} 
          onValueChange={setAttractionType}
          disabled={isExistingPlace}
        >
          <SelectTrigger className={isExistingPlace ? "bg-gray-50" : ""}>
            <SelectValue placeholder="Select attraction type" />
          </SelectTrigger>
          <SelectContent>
            <SelectItem value="museum">Museum</SelectItem>
            <SelectItem value="historical_site">Historical Site</SelectItem>
            <SelectItem value="natural_landmark">Natural Landmark</SelectItem>
            <SelectItem value="beach">Beach</SelectItem>
            <SelectItem value="park">Park</SelectItem>
            <SelectItem value="viewpoint">Viewpoint</SelectItem>
            <SelectItem value="entertainment">Entertainment</SelectItem>
            <SelectItem value="other">Other</SelectItem>
          </SelectContent>
        </Select>
      </div>

      <div className="space-y-2">
        <Label>Entrance Fee</Label>
        <Input
          type="text"
          value={entranceFee}
          onChange={(e) => setEntranceFee(e.target.value)}
          placeholder="e.g., $15, Free on Sundays"
          className={isExistingPlace ? "bg-gray-50" : ""}
          readOnly={isExistingPlace}
        />
      </div>

      <div className="space-y-2">
        <Label>Suggested Duration (hours)</Label>
        <Input
          type="text"
          value={suggestedDuration}
          onChange={(e) => setSuggestedDuration(e.target.value)}
          placeholder="e.g., 1-2, 3+"
          className={isExistingPlace ? "bg-gray-50" : ""}
          readOnly={isExistingPlace}
        />
      </div>

      <div className="space-y-2">
        <Label>Best Time to Visit</Label>
        <Input
          value={bestTimeToVisit}
          onChange={(e) => setBestTimeToVisit(e.target.value)}
          placeholder="e.g., Morning, Spring season"
          className={isExistingPlace ? "bg-gray-50" : ""}
          readOnly={isExistingPlace}
        />
      </div>

      <div className="space-y-2">
        <Label>Key Exhibits/Features</Label>
        <Textarea
          value={exhibits}
          onChange={(e) => setExhibits(e.target.value)}
          placeholder="Main exhibits or features to see"
          className={isExistingPlace ? "bg-gray-50" : ""}
          readOnly={isExistingPlace}
        />
      </div>

      <div className="space-y-2">
        <Label>Historical Significance</Label>
        <Textarea
          value={historicalSignificance}
          onChange={(e) => setHistoricalSignificance(e.target.value)}
          placeholder="Any notable historical information"
          className={isExistingPlace ? "bg-gray-50" : ""}
          readOnly={isExistingPlace}
        />
      </div>

      <div className="flex items-center space-x-2">
        <Switch
          checked={isIndoor}
          onCheckedChange={setIsIndoor}
          disabled={isExistingPlace}
        />
        <Label className={isExistingPlace ? "text-muted-foreground" : ""}>
          Indoor Attraction
        </Label>
      </div>
    </div>
  );
}
